/**
 * The pricing "edit" a visitor clicked "Book" on in <PricingEdits>, stashed so
 * the page's shared <WaitlistDialog> can attach it to their waitlist submission
 * (the `edit_source` column) without threading state through every landing page.
 *
 * Contract:
 *   - PricingEdits.book()      → setPendingEditSource(edit.name) right before it
 *                                opens the waitlist dialog.
 *   - WaitlistDialog submit    → getPendingEditSource() reads it into the insert.
 *   - WaitlistDialog close      → clearPendingEditSource() wipes it, so a later
 *                                waitlist open from a NON-edit CTA records null.
 *
 * Safe against staleness: the dialog is modal, so a visitor can't click an edit
 * card while it's open — the value is only ever set immediately before an open
 * and is cleared on every close.
 */
let pendingEditSource: string | null = null;

export const setPendingEditSource = (value: string | null) => {
  pendingEditSource = value;
};

export const getPendingEditSource = (): string | null => pendingEditSource;

export const clearPendingEditSource = () => {
  pendingEditSource = null;
};
